// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","wrapper":"Navbar_wrapper__X6Cld","select-wrapper":"Navbar_select-wrapper__C36sK","fadeIn":"Navbar_fadeIn__6sHX4","fadeOut":"Navbar_fadeOut__8GZ+K"};